// Generated by Melange

import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import EyeClosedSvg from "static/icons/eye-closed.svg";
import EyeOpenedSvg from "static/icons/eye-opened.svg";

function ProfileSecurityPage(Props) {
  const match = React.useState(function () {
        return "";
      });
  const setCurrentPassword = match[1];
  const match$1 = React.useState(function () {
        return true;
      });
  const setCurrentPasswordHidden = match$1[1];
  const currentPasswordHidden = match$1[0];
  const match$2 = React.useState(function () {
        return "";
      });
  const setNewPassword = match$2[1];
  const match$3 = React.useState(function () {
        return true;
      });
  const setNewPasswordHidden = match$3[1];
  const newPasswordHidden = match$3[0];
  const match$4 = React.useState(function () {
        return "";
      });
  const setPasswordRepeat = match$4[1];
  const match$5 = React.useState(function () {
        return true;
      });
  const setPasswordRepeatHidden = match$5[1];
  const passwordRepeatHidden = match$5[0];
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Безопасность"
      });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                  className: "text-default-gray",
                                  children: "Смена пароля"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                          label: "Текущий пароль",
                                          type_: currentPasswordHidden ? "password" : "text",
                                          name: "currentPassword",
                                          required: true,
                                          onChange: (function (value) {
                                              Curry._1(setCurrentPassword, (function (param) {
                                                      return value;
                                                    }));
                                            }),
                                          autoComplete: "off",
                                          value: match[0]
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: currentPasswordHidden ? JsxRuntime.jsx(EyeClosedSvg, {}) : JsxRuntime.jsx(EyeOpenedSvg, {}),
                                          className: "absolute right-4 top-4",
                                          tabIndex: -1,
                                          type: "button",
                                          onClick: (function (param) {
                                              Curry._1(setCurrentPasswordHidden, (function (param) {
                                                      return !currentPasswordHidden;
                                                    }));
                                            })
                                        })
                                  ],
                                  className: "relative mt-3"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                          label: "Новый пароль",
                                          type_: newPasswordHidden ? "password" : "text",
                                          name: "newPassword",
                                          required: true,
                                          onChange: (function (value) {
                                              Curry._1(setNewPassword, (function (param) {
                                                      return value;
                                                    }));
                                            }),
                                          autoComplete: "off",
                                          value: match$2[0]
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: newPasswordHidden ? JsxRuntime.jsx(EyeClosedSvg, {}) : JsxRuntime.jsx(EyeOpenedSvg, {}),
                                          className: "absolute right-4 top-4",
                                          tabIndex: -1,
                                          type: "button",
                                          onClick: (function (param) {
                                              Curry._1(setNewPasswordHidden, (function (param) {
                                                      return !newPasswordHidden;
                                                    }));
                                            })
                                        })
                                  ],
                                  className: "relative mt-4"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                          label: "Повторите новый пароль",
                                          type_: passwordRepeatHidden ? "password" : "text",
                                          name: "passwordRepeat",
                                          required: true,
                                          onChange: (function (value) {
                                              Curry._1(setPasswordRepeat, (function (param) {
                                                      return value;
                                                    }));
                                            }),
                                          autoComplete: "off",
                                          value: match$4[0]
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: passwordRepeatHidden ? JsxRuntime.jsx(EyeClosedSvg, {}) : JsxRuntime.jsx(EyeOpenedSvg, {}),
                                          className: "absolute right-4 top-4",
                                          tabIndex: -1,
                                          type: "button",
                                          onClick: (function (param) {
                                              Curry._1(setPasswordRepeatHidden, (function (param) {
                                                      return !passwordRepeatHidden;
                                                    }));
                                            })
                                        })
                                  ],
                                  className: "relative mt-4"
                                }),
                            JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                  title: "Сохранить",
                                  className: "mt-4 w-full py-3"
                                })
                          ],
                          className: "bg-white w-140.5 px-10 py-6 mt-6 rounded shadow-card"
                        }),
                    className: "w-full flex flex-col items-center"
                  }),
              className: "bg-gray-pale"
            });
}

const make = ProfileSecurityPage;

export {
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
